export enum KontaktListLinkRel {
	KONTAKT_LIST = 'kontaktList',
	CREATE = 'create',
}

export enum KontaktLinkRel {
	EDIT = 'edit',
	DELETE = 'delete',
	VERFAHREN_NOTIZ = 'verfahrenNotiz',
	VERFAHREN_AKTENZEICHEN = 'verfahrenAktenzeichen',
	VERFAHREN_BY_KONTAKT = 'verfahrenByKontakt',
}

export enum VerfahrenKontaktLinkRel {
	EDIT_FREITEXT = 'editFreitext',
}
